module.exports = __webpack_public_path__ + "img/hr-grass.7cedf547.png";